import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
import {getSimplexService} from 'services/sports/factory';

export class LpClassic extends BaseLP {
    team({incomingValues = {}}) {
        const {sportConfig} = Action.getState();
        const constraints = getSimplexService(sportConfig, {store: this.store}).exec('team', {...incomingValues}, []);

        let result = '';
        if (!isEmpty(constraints)) {
            result = this.exec(
                'convertConstraintsOfMultiPositionPlayersToStr',
                {
                    constraints,
                },
                '',
            );
        }

        return result;
    }

    limitPositions({incomingValues = {}}) {
        const {sportConfig} = Action.getState();
        const constraints = getSimplexService(sportConfig, {store: this.store}).exec(
            'limitPositions',
            {...incomingValues},
            [],
        );

        let result = '';
        if (!isEmpty(constraints)) {
            result = this.exec(
                'convertConstraintsOfMultiPositionPlayersToStr',
                {
                    constraints,
                },
                '',
            );
        }

        return result;
    }
}
